import { Archive, ArrowRight, FileText } from 'react-feather'
import { CardBody, Col, Row } from 'reactstrap'
import { Badges, H4, LI, UL } from '../../../../AbstractElements'
import { Link } from 'react-router-dom'
import { Href } from '../../../../utils/Constant'
import { knowledgeBaseData } from '../../../../Data/Miscellaneous/KnowledgeBase/KnowledgeBase'

const CategoryDataCardBody = () => {
  return (
    <CardBody>
      <Row className="browse g-sm-4 g-3">
        {knowledgeBaseData.map((data) => (
          <Col xl="4" md="6" key={data.id} className="box-col-33">
            <div className="browse-articles">
              <H4>
                <span><Archive className="feather feather-archive" /></span>{data.title}
              </H4>
              <UL className='simple-list'>
                {data.knowledgeList &&
                  data.knowledgeList.map((item, index2) => (
                    <LI key={index2} className="border-0">
                      <Link to={Href} className={item.text.includes("See More") ? "f-w-600 font-primary" : ""}>
                        {item.fileTextIcon ? (<span><FileText /></span>) : (<span><ArrowRight /></span>)}
                        <span>{item.text}</span>
                        {item.badge ? <Badges color="primary" className="pull-right">{item.badge}</Badges> : " "}
                      </Link>
                    </LI>
                  ))}
              </UL>
            </div>
          </Col>
        ))}
      </Row>
    </CardBody>
  )
}

export default CategoryDataCardBody